export namespace S3 {
  export const MimeType = {
    'text/plain': 0,
    'text/html': 1,
    'text/css': 2,
    'text/javascript': 3,
    'image/gif': 10,
    'image/png': 11,
    'image/jpeg': 12,
    'image/heic': 13,
    'image/bmp': 14,
    'image/webp': 15,
    'audio/midi': 20,
    'audio/mpeg': 21,
    'audio/webm': 22,
    'audio/ogg': 23,
    'audio/wav': 24,
    'video/webm': 30,
    'video/ogg': 31,
    'video/mp4': 32,
    'video/quicktime': 33,
    'application/pdf': 40,
    'application/xml': 41,
    'application/xhtml+xml': 42,
    'application/vnd.mspowerpoint': 43,
    'application/pkcs12': 44,
    'application/octet-stream': 45,
  } as const

  export type MimeType = (typeof MimeType)[keyof typeof MimeType]

  export const ResourceType = {
    VET_LICENSE: 0,
    VET_PROFILE: 1,
    VET_EDUCATION_CERTIFICATE: 2,
    FEEDBACK_IMAGE: 100,
    PET_PROFILE: 101,
    QUESTION_IMAGE: 102,
    QUESTION_VIDEO: 104,
    OWNER_PROFILE: 103,
    COMMUNITY_IMAGE: 400,
    COMMUNITY_VIDEO: 401,
    MEDICAL_RECORD_ORIGINAL: 200,
    MEDICAL_RECORD_PROCESSED: 201,
    VACCINE_RECORD_VACCINE_LABEL: 202,
    MEDICAL_RECORD_MEMO_IMAGE: 203,
    // TODO set 204 if back api is successfully modified.
    VACCINE_RECORD_MEMO_IMAGE: 203,
    TMP: 999,
    MEDICAL_RECORD_IMAGE: 206,
  } as const

  export type ResourceType = (typeof ResourceType)[keyof typeof ResourceType]

  export interface IPresignFields extends Record<string, string> {
    acl: string
    key: string
    policy: string
  }
  export interface IPresignMetadata {
    cdn: string
    url: string
    fields: IPresignFields
  }

  export class PreSignedPost implements IPresignMetadata {
    cdn = ''
    url = ''
    fields: IPresignFields

    constructor(json: PreSignedPost.Response) {
      this.cdn = json.cdn
      this.url = json.url
      this.fields = json.fields
      return { ...this }
    }

    private static isDev() {
      if (import.meta.env.PROD) {
        return false
      }

      return true
    }
  }

  export namespace PreSignedPost {
    export interface Response {
      cdn: string
      url: string
      fields: IPresignFields
    }

    export class Request {
      resource_type: ResourceType | undefined = undefined
      mime_type: MimeType | undefined = undefined

      constructor(data: Request) {
        this.resource_type = data.resource_type
        this.mime_type = data.mime_type
        return { ...this }
      }
    }
  }

  export class DevRequest {
    formData: FormData = new FormData()

    constructor(file: File, fields: IPresignFields) {
      if (!file) {
        throw new Error('data file is missing!')
      }

      // ! The append order must not be changed.
      Object.entries(fields).forEach(([field, value]) => {
        this.formData.append(field, value)
      })
      this.formData.append('file', file)

      return { ...this }
    }
  }

  export class ProdRequest {
    formData: FormData = new FormData()

    constructor(file: File, fields: IPresignFields) {
      if (!file) {
        throw new Error('data file is missing!')
      }

      // ! The append order must not be changed.
      Object.entries(fields).forEach(([field, value]) => {
        this.formData.append(field, value)
      })
      this.formData.append('file', file)

      return { ...this }
    }
  }

  export interface AdditionalData {
    thumbnail_url: string
    converted_video_url: string
  }

  export interface ConvertedVideo {
    file_url: string
    file_name: string
    mime_type: MimeType | undefined
    acl: string
    additional_data: AdditionalData
  }
  export namespace ConvertedVideo {
    export class Request {
      from_web = '1'
      file_key = ''

      constructor(key: string) {
        this.file_key = key
      }
    }
  }
}
